// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-info-close {
    background-color: #d22e37;
}

.audit-item-info-header {
    font-size: xx-large;
}

.audit-item-info-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: space-between;
}

.audit-item-info-container div{
    margin-top: 1rem;
    border-bottom: 1px solid gray;
}

.audit-item-info-label{
    width: 10rem;
}

.audit-item-info-container span {
    display: inline-block;
    overflow-wrap: break-word;
    inline-size: 100%;
}

.audit-item-info-audit-data {
    display: inline-block;
    max-height: 30rem;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/audit/audit-main/audit-list/audit-item/audit-item-info/AuditItemInfo.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".audit-info-close {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.audit-item-info-header {\r\n    font-size: xx-large;\r\n}\r\n\r\n.audit-item-info-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    justify-content: space-between;\r\n}\r\n\r\n.audit-item-info-container div{\r\n    margin-top: 1rem;\r\n    border-bottom: 1px solid gray;\r\n}\r\n\r\n.audit-item-info-label{\r\n    width: 10rem;\r\n}\r\n\r\n.audit-item-info-container span {\r\n    display: inline-block;\r\n    overflow-wrap: break-word;\r\n    inline-size: 100%;\r\n}\r\n\r\n.audit-item-info-audit-data {\r\n    display: inline-block;\r\n    max-height: 30rem;\r\n    overflow-y: auto;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
